import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "utils/AuthContext";
import { FlexLeftCol, Group } from "styles/global-style";
import Checkbox from "components/Checkbox";

const getEnabledFromSetting = (settings, settingName, defaultValue = true) => {
  const rawValue = settings?.find((s) => s.name === settingName)?.value;
  if (rawValue === undefined || rawValue === null) return defaultValue;
  return rawValue === true || rawValue === "true";
};

export default function General() {
  const { supabase, user, refresh } = useContext(AuthContext);
  const [workTabEnabled, setWorkTabEnabled] = useState(true);
  const [projectTabEnabled, setProjectTabEnabled] = useState(true);

  const toggleSetting = useCallback(
    async (name, value, setterCb) => {
      const setting = user.proj.settings.find((s) => s.name === name);
      setterCb(value);
      if (setting) await supabase.from("settings").update({ value: value }).eq("id", setting.id);
      else await supabase.from("settings").insert({ name: name, value: value, project_id: user.proj.id });
      refresh();
    },
    [user, supabase, refresh]
  );

  useEffect(() => {
    if (!user?.proj?.settings) return;
    setWorkTabEnabled(getEnabledFromSetting(user.proj.settings, "workTabEnabled"));
    setProjectTabEnabled(getEnabledFromSetting(user.proj.settings, "projectTabEnabled"));
  }, [user]);

  return (
    <FlexLeftCol>
      <h2>General</h2>
      <Group caption="Main menu tabs" white>
        <Checkbox text="Work tab enabled" checked={workTabEnabled} onChangeCb={() => toggleSetting("workTabEnabled", !workTabEnabled, setWorkTabEnabled)} white />
        <Checkbox
          text="Project tab enabled"
          checked={projectTabEnabled}
          onChangeCb={() => toggleSetting("projectTabEnabled", !projectTabEnabled, setProjectTabEnabled)}
          white
        />
      </Group>
    </FlexLeftCol>
  );
}
